import { render, staticRenderFns } from "./AssetTags.vue?vue&type=template&id=75a88b82&"
import script from "./AssetTags.vue?vue&type=script&lang=js&"
export * from "./AssetTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports